export type TableSortInfo = {
  column: string;
  direction: 'asc' | 'desc';
};

export enum ETableFilterTypes {
  Date,
  Text,
  DateRange,
}

export type FilterValue = {
  type: ETableFilterTypes;
  value: string | number | DateRangeFilter;
};

export type DateRangeFilter = {
  start: string;
  end: string;
};

export type CustomTableColumns = {
  key: string;
  title: string;
  className?: string;
  filterType?: ETableFilterTypes;
  disableSort?: boolean;
};

export type CustomTableProps = {
  data: any[];
  columns: CustomTableColumns[];
  id: string;
  rowsPerPage?: number;
  enableSelection?: boolean;
  autoSelectAll?: boolean;
  onCountsChange?: (counts: {
    total: number;
    selected: number;
    selectedExperimentIds: number[];
  }) => void;
  sortInfo?: TableSortInfo;
};
